export type ParsedQrPayload = {
  code: string;
  material: string;
};

export function parseStockCountQrPayload(payload: string): ParsedQrPayload {
  const separatorIndex = payload.indexOf(" - ");
  if (separatorIndex < 0) {
    throw new Error('QR inválido. Use o formato "Código - Material".');
  }

  const code = payload.slice(0, separatorIndex).trim();
  const material = payload.slice(separatorIndex + 3).trim();
  if (!code || !material) {
    throw new Error("QR inválido. Código e material são obrigatórios.");
  }

  return { code, material };
}
